// => GET revenue overview
const GET_ALL_TRANSACTIONS = `/transactions`;

export const transactionsEndpoints = {
    GET_ALL_TRANSACTIONS,
};
